import SideBar from './SideBar.container'

export default SideBar
